export default {
  button: {
    add: 'Add',
    insert: 'Insert',
    update: 'Update',
    cancel: 'Cancel',
    duplicate: 'Duplicate',
    rectify: 'Rectify',
    back: 'Back',
    delete: 'Delete',
    search: 'Search',
    save: 'Save',
    continue: 'Continue',
    send: 'Send',
    issue: 'Issue',
    export: 'Export {0}',
    accept: 'Accept',
    close: 'Close',
    watchAll: 'See all',
    undo: 'Undo',
    newElement: 'New item',
    create: 'Creat',
    watchConditions: 'Terms of service',
    reject: 'Reject',
    unreject: 'Unreject',
    view: 'View',
    edit: 'Edit',
    ok: 'Ok',
    cancelInvoice: 'Cancel invoice',
    acceptCancel: 'Accept invoice cancellation',
    rejectCancel: 'Reject invoice cancellation'
  },
  sharedInfo: {
    requiredFields: '(*) Required fields'
  },
  pagination: {
    showing: 'Showing'
  },
  file: {
    select: 'Select file',
    noneSelected: 'No file selected'
  },
  spinner: {
    loading: 'Loading...',
    processing: 'Processing'
  },
  error: 'An error has occurred'
}
